<template>
  <div>
    <div class="cmd-group">
      <div class="form-group noMB">
        <b>CUI*</b>
        <div class="RForm">
          <input
            type="text"
            class="vInput form-disabled"
            v-model="form.cui"
            :disabled="true"
          />
        </div>
      </div>
      <div class="form-group noMB">
        <b>Denumire*</b>
        <div class="RForm">
          <input
            type="text"
            class="vInput form-disabled"
            v-model="form.name"
            :disabled="true"
          />
        </div>
      </div>
    </div>

    <div class="form-group">
      <b>Tip persoană juridică*</b>
      <v-select
        v-model="form.type"
        label="name"
        :options="providerTypes"
        :filter="diacriticFilter"
        placeholder="Selectați tip persoană juridică"
        append-to-body
      />
    </div>

    <div v-if="anafAddress" class="legal-entity-anaf-address">
      {{ anafAddress }}
    </div>

    <div class="cmd-group">
      <div class="form-group">
        <b>Județul*</b>
        <v-select
          v-model="selectedCounty"
          :options="counties"
          label="name"
          :filter="diacriticFilter"
          placeholder="Selectați Județul"
          @input="onCountyChange"
          append-to-body
        />
      </div>
      <div class="form-group">
        <b>Localitatea*</b>
        <v-select
          v-model="selectedCity"
          :options="cities"
          label="name"
          :filter="diacriticFilter"
          placeholder="Selectați Localitatea"
          :disabled="!selectedCounty"
          :loading="loadingCities"
          @input="onCityChange"
          append-to-body
        />
      </div>
      <div class="form-group">
        <b>Strada*</b>
        <v-select
          v-model="selectedStreet"
          :options="streets"
          label="name"
          :filter="diacriticFilter"
          placeholder="Alegeți strada"
          :disabled="!selectedCity"
          :loading="loadingStreets"
          @input="
            (val) => {
              form.street = val ? val.name : '';
              form.street_id = val ? val.id : null;
            }
          "
          append-to-body
        />
      </div>
    </div>

    <div class="cmd-group legal-entity-address-details">
      <div class="form-group">
        <b>Nr.</b>
        <input type="text" class="vInput" v-model="form.number" />
      </div>
      <div class="form-group">
        <b>Bl.</b>
        <input type="text" class="vInput" v-model="form.building" />
      </div>
      <div class="form-group">
        <b>Sc.</b>
        <input type="text" class="vInput" v-model="form.staircase" />
      </div>
      <div class="form-group">
        <b>Et.</b>
        <input type="text" class="vInput" v-model="form.floor" />
      </div>
      <div class="form-group">
        <b>Ap.</b>
        <input type="text" class="vInput" v-model="form.apartment" />
      </div>
    </div>
  </div>
</template>

<script>
import { INSTITUTION_PROVIDERS } from "../api";

export default {
  props: {
    cuiInfo: { type: Object, required: true },
  },
  data() {
    return {
      form: {
        cui: this.cuiInfo.cui,
        name: this.cuiInfo.name,
        type: "",
        email: "",
        phone: "",
        county: "",
        county_id: null,
        city: "",
        city_id: null,
        street: "",
        street_id: null,
        number: "",
        building: "",
        staircase: "",
        floor: "",
        apartment: "",
      },
      anafAddress: this.cuiInfo.adresa,
      counties: [],
      cities: [],
      streets: [],
      selectedCounty: null,
      selectedCity: null,
      selectedStreet: null,
      loadingCities: false,
      loadingStreets: false,
      providerTypes: [],
    };
  },

  watch: {
    form: {
      handler(val) {
        this.$emit("input", { ...val });
      },
      deep: true,
      immediate: true,
    },
  },

  methods: {
    diacriticFilter(options, search) {
      const term = this.normalize(search).toLowerCase();

      return options.filter((opt) =>
        this.normalize(typeof opt === "object" ? opt.name : opt)
          .toLowerCase()
          .includes(term),
      );
    },

    async onCountyChange(county) {
      this.selectedCity = null;
      this.selectedStreet = null;
      this.cities = [];
      this.streets = [];
      this.form.county = county ? county.name : "";
      this.form.county_id = county ? county.id : null;
      this.form.city = "";
      this.form.city_id = null;
      this.form.street = "";
      this.form.street_id = null;

      if (!county) return;

      this.initCities(county.id);
    },

    async onCityChange(city) {
      this.selectedStreet = null;
      this.streets = [];
      this.form.city = city ? city.name : "";
      this.form.city_id = city ? city.id : null;
      this.form.street = "";
      this.form.street_id = null;

      if (!city) return;

      this.initStreets(city.id);
    },

    async initLegalEntityTypes() {
      const response = await INSTITUTION_PROVIDERS.getLegalEntityTypes();

      if (this.checkHttpStatusCode(response?.meta?.HttpStatusCode)) {
        this.providerTypes = response.data;
      } else {
        this.$toastr.e(
          "Tipurile de persoane juridice nu au putut fi încărcate.",
        );
      }
    },

    async initCounties() {
      const response = await INSTITUTION_PROVIDERS.getCounties();

      if (this.checkHttpStatusCode(response?.meta?.HttpStatusCode)) {
        this.counties = response.data;
      } else {
        this.$toastr.e("Județele nu au putut fi încărcate.");
      }
    },

    async initCities(countyId) {
      this.loadingCities = true;

      const response = await INSTITUTION_PROVIDERS.getCities(countyId);

      if (this.checkHttpStatusCode(response?.meta?.HttpStatusCode)) {
        this.cities = response.data;
      } else {
        this.$toastr.e("Localitățile nu au putut fi încărcate.");
      }

      this.loadingCities = false;
    },

    async initStreets(uatId) {
      this.loadingStreets = true;

      const response = await INSTITUTION_PROVIDERS.getStreets(uatId);

      if (this.checkHttpStatusCode(response?.meta?.HttpStatusCode)) {
        this.streets = response.data;
      } else {
        this.$toastr.e("Strazile nu au putut fi încărcate.");
      }

      this.loadingStreets = false;
    },
  },

  async created() {
    this.initLegalEntityTypes();
    this.initCounties();
  },
};
</script>

<style lang="scss">
.legal-entity-anaf-address {
  background: #e8f4fd;
  color: #1a73e8;
  border-radius: 4px;
  padding: 1rem 1.2rem;
  margin-bottom: 1rem;
  font-weight: 500;
  font-size: 1.6rem;
}

.legal-entity-address-details {
  .form-group {
    flex: 0 0 auto;
    min-width: 7rem;
  }
}
</style>
